import { LinkOptions } from '../../lib/types';
import {
  HOTELS_HOST,
  QH_LIST_URL,
  CONTACT_US,
  FAQS,
  PRIVACY_AND_SECURITY_URL,
  TERMS_OF_USE_URL,
  DESTINATIONS_AUSTRALIA,
  QH_DEALS_URL,
  HOLIDAY_DEALS,
  QCOM_LANDING_PAGE_URL,
  QH_SELF_SERVICE_URL,
} from '../../lib/config';

export const SupportLinks: LinkOptions[] = [
  {
    trackingName: 'Manage bookings',
    href: QH_SELF_SERVICE_URL,
    'data-testid': 'manage-hotels-bookings',
    children: 'Manage Hotels Bookings',
  },
  {
    trackingName: 'FAQs',
    href: FAQS,
    'data-testid': 'faqs-link',
    children: 'FAQs',
  },
  {
    trackingName: 'Contact Us',
    href: CONTACT_US,
    'data-testid': 'contact-link',
    children: 'Contact Us',
  },
];

export const DisclaimerLinks: LinkOptions[] = [
  {
    trackingName: 'Privacy and security',
    href: PRIVACY_AND_SECURITY_URL,
    'data-testid': 'privacy-security-link',
    children: 'Privacy & Security',
  },
  {
    trackingName: 'Terms of use',
    href: TERMS_OF_USE_URL,
    'data-testid': 'term-of-use-link',
    children: 'Terms of use',
  },
];

export const HotelsLinks: LinkOptions[] = [
  {
    trackingName: 'Hotels',
    href: QH_LIST_URL,
    'data-testid': 'hotels-link',
    children: 'Hotels',
    usesQueryParams: true,
  },
  {
    trackingName: 'Destinations',
    href: DESTINATIONS_AUSTRALIA,
    'data-testid': 'destination-link',
    children: 'Destinations',
  },
  {
    trackingName: 'Hotels Deals',
    href: QH_DEALS_URL,
    'data-testid': 'deals-link',
    children: 'Hotel Deals',
  },
  {
    trackingName: 'Luxury Holidays',
    href: HOLIDAY_DEALS,
    'data-testid': 'luxe-link',
    children: 'Luxury Holidays',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Airbnb',
    href: QCOM_LANDING_PAGE_URL,
    'data-testid': 'airbnb-link',
    children: 'Airbnb',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
];

export const AustraliaDestinationCitiesLinks: LinkOptions[] = [
  {
    children: 'Melbourne',
    'data-testid': 'melbourne-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/vic/melbourne`,
    trackingName: 'Melbourne Destination',
  },
  {
    children: 'Sydney',
    'data-testid': 'sydney-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/nsw/sydney`,
    trackingName: 'Sydney Destination',
  },
  {
    children: 'Brisbane',
    'data-testid': 'brisbane-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/qld/brisbane`,
    trackingName: 'Brisbane Destination',
  },
  {
    children: 'Perth',
    'data-testid': 'perth-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/wa/perth`,
    trackingName: 'Perth Destination',
  },
  {
    children: 'Adelaide',
    'data-testid': 'adelaide-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/sa/adelaide`,
    trackingName: 'Adelaide Destination',
  },
  {
    children: 'Darwin',
    'data-testid': 'darwin-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/nt/darwin`,
    trackingName: 'Darwin Destination',
  },
  {
    children: 'Cairns',
    'data-testid': 'cairns-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/qld/cairns`,
    trackingName: 'Cairns Destination',
  },
  {
    children: 'Surfers Paradise',
    'data-testid': 'surfers-paradise-destinations-link',
    href: `${HOTELS_HOST}/hotels/australia/qld/surfers-paradise`,
    trackingName: 'Surfers Paradise Destination',
  },
];

export const AustraliaDestinationStatesLinks: LinkOptions[] = [
  {
    children: 'Queensland',
    href: `${HOTELS_HOST}/hotels/australia/qld`,
    trackingName: 'Queensland Destination',
  },
  {
    children: 'New South Wales',
    href: `${HOTELS_HOST}/hotels/australia/nsw`,
    trackingName: 'New South Wales Destination',
  },
  {
    children: 'Victoria',
    href: `${HOTELS_HOST}/hotels/australia/vic`,
    trackingName: 'Victoria Destination',
    'data-testid': 'destination-victoria',
  },
  {
    children: 'Western Australia',
    href: `${HOTELS_HOST}/hotels/australia/wa`,
    trackingName: 'Western Australia Destination',
  },
  {
    children: 'Northern Territory',
    href: `${HOTELS_HOST}/hotels/australia/nt`,
    trackingName: 'Northern Territory Destination',
  },
  {
    children: 'South Australia',
    href: `${HOTELS_HOST}/hotels/australia/sa`,
    trackingName: 'South Australia Destination',
  },
  {
    children: 'Tasmania',
    href: `${HOTELS_HOST}/hotels/australia/tas`,
    trackingName: 'Tasmania Destination',
  },
  {
    children: 'Australian Capital Territory',
    href: `${HOTELS_HOST}/hotels/australia/act`,
    trackingName: 'Australian Capital Territory Destination',
  },
];
